'use client';

import { Button } from '@/components/ui/button';
import type { LoginButtonProps } from '@/types/auth-types';
import { LogIn } from 'lucide-react';
import { useLocale } from 'next-intl';
import { useRouter } from 'next/navigation';

function LoginButton({ onItemClick, t }: LoginButtonProps) {
  const router = useRouter();
  const locale = useLocale();
  const signInSlug = locale === 'sk' ? 'prihlasenie' : 'sign-in';

  return (
    <Button
      variant='brandOutline'
      size='sm'
      className='group flex gap-2 px-4 py-2 w-full justify-center'
      onClick={() => {
        if (onItemClick) onItemClick();
        router.push(`/${locale}/${signInSlug}`);
      }}
    >
      <LogIn className='h-4 w-4 transition-transform duration-300 group-hover:translate-x-[-2px]' />
      <span className='font-medium text-sm'>{t('signIn')}</span>
    </Button>
  );
}

export default LoginButton;
